(() => {
  document.querySelectorAll('.sb-gvm-hub').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const buttons = [...root.querySelectorAll('[data-gvm-filter]')];
    const items = [...root.querySelectorAll('[data-gvm-family][data-gvm-weight]')];
    const host = root.querySelector('[data-gvm-catalogue]');
    const rating = root.querySelector('[data-gvm-weight-filter]');
    const search = root.querySelector('[data-gvm-search]');
    const result = root.querySelector('.sb-gvm-results');
    if (!host || !rating || !search) return;
    const familyOrder = buttons.map(b => b.dataset.gvmFilter);
    items.sort((a,b) => familyOrder.indexOf(a.dataset.gvmFamily)-familyOrder.indexOf(b.dataset.gvmFamily) || a.dataset.gvmVehicle.localeCompare(b.dataset.gvmVehicle) || Number(a.dataset.gvmWeight)-Number(b.dataset.gvmWeight) || Number(a.dataset.gvmPrice)-Number(b.dataset.gvmPrice) || a.dataset.gvmSku.localeCompare(b.dataset.gvmSku));
    const tiers = new Map();
    items.forEach(item => {
      const key = item.dataset.gvmVehicle+'|'+item.dataset.gvmWeight;
      if (!tiers.has(key)) {
        const section = document.createElement('section');
        section.className = 'sb-gvm-tier';
        const title = document.createElement('h2');
        title.textContent = item.dataset.gvmVehicle+' · '+Number(item.dataset.gvmWeight).toLocaleString('en-AU')+'kg GVM';
        const count = document.createElement('span'); count.className = 'sb-gvm-tier-count'; title.append(count);
        const grid = document.createElement('div'); grid.className = 'sb-gvm-tier-grid';
        section.append(title,grid); host.append(section); tiers.set(key,{section,grid,count,items:[]});
      }
      const tier = tiers.get(key); tier.grid.append(item); tier.items.push(item);
    });
    let family = 'all';
    const fits = item => family === 'all' || item.dataset.gvmFamily === family;
    function updateRatings() {
      const previous = rating.value;
      rating.replaceChildren(new Option('All ratings — light to heavy','all'));
      [...new Set(items.filter(fits).map(i=>Number(i.dataset.gvmWeight)))].sort((a,b)=>a-b).forEach(n=>rating.add(new Option(n.toLocaleString('en-AU')+'kg',String(n))));
      if ([...rating.options].some(o=>o.value===previous)) rating.value=previous;
    }
    function render() {
      const term=search.value.trim().toLowerCase();let count=0;
      items.forEach(item=>{const visible=fits(item)&&(rating.value==='all'||item.dataset.gvmWeight===rating.value)&&(!term||(item.textContent+' '+item.dataset.gvmSku).toLowerCase().includes(term));item.hidden=!visible;if(visible)count++;});
      tiers.forEach(t=>{const n=t.items.filter(i=>!i.hidden).length;t.section.hidden=n===0;t.count.textContent=n+' '+(n===1?'kit option':'kit options')+' · Customer RRP';});
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.gvmFilter===family)));
      root.querySelectorAll('[data-gvm-pending-family]').forEach(el=>{el.hidden=family!=='all'&&el.dataset.gvmPendingFamily!==family;});
      const pending=root.querySelector('.sb-gvm-pending');if(pending)pending.hidden=![...pending.querySelectorAll('[data-gvm-pending-family]')].some(el=>!el.hidden);
      result.textContent=count+' '+(count===1?'kit':'kits')+' shown · Light to heavy within each vehicle'+(count===0?' — try another rating or clear your search.':'');
    }
    function choose(value){family=buttons.some(b=>b.dataset.gvmFilter===value)?value:'all';updateRatings();render();}
    buttons.forEach(b=>b.addEventListener('click',()=>{rating.value='all';choose(b.dataset.gvmFilter);history.replaceState(null,'','#gvm-'+family);}));
    rating.addEventListener('change',render);search.addEventListener('input',render);
    root.querySelector('[data-gvm-reset]').addEventListener('click',()=>{search.value='';rating.value='all';choose('all');history.replaceState(null,'','#gvm-all');});
    window.addEventListener('hashchange',()=>choose(location.hash.replace('#gvm-','')));
    choose(location.hash.replace('#gvm-',''));
  });
})();
